import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["code"]

    connect() {
        // Preserve browser-restored and autofilled values on Turbo reconnect.
        this.input()
    }

    input() {
        this.codeTarget.value = this.codeTarget.value.replace(/\D/g, "").slice(0, 6)
    }

    paste(event) {
        // Normalize before maxlength can truncate a spaced code (e.g. "012 345").
        const digits = event.clipboardData?.getData("text").replace(/\D/g, "")
        if (!digits) return
        event.preventDefault()
        this.codeTarget.value = digits.slice(0, 6)
        this.codeTarget.dispatchEvent(new Event("input", { bubbles: true }))
    }
}
